import React from 'react';
import '../App.css';
import programmer  from '../images/programmer.svg'

function Footer() {
    return (
      <footer className='footer'>
        <p>Created by <a className='insta' href='https://www.instagram.com/_zhan1bekov_/'>YELAMAN JANIBEKOV</a> </p>
        
      </footer>
    );
  }
  
  export default Footer;